export const ID_UNIT_ML_DIA = 1;
export const ID_UNIT_ML_KG_DIA = 5;

export interface IMeasurementUnit {
  id?: string;
  nome: string;
  sigla: string;
  ml?: number;
}
